<!-- eslint-disable -->
<template lang="pug">
  game-preview-settings(v-if="parameters")
    game-preview-setting
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
      span(slot="value") {{ $i18n.t('common.common_gameName_factorization') }}
    game-preview-setting(v-if="parameters.amountOfExamples && !parameters.timeLimit")
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}
      span(slot="value") {{ parameters.amountOfExamples }}
    game-preview-setting(v-if="parameters.timeLimit")
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
      span(slot="value") {{ timeLimit }}
    template(v-if="parameters.dictation")
      game-preview-setting
        span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_dictation') }}
        span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
      game-preview-setting
        span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
        span(slot="value")
          | {{ parameters.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
    game-preview-setting(v-if="parameters.numbers.length !== 0")
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_multipliers') }}
      span(slot="value") {{ parameters.numbers.join(', ') }}
    game-preview-setting(v-if="parameters.showAnswer")
      span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_answers') }}
      span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
</template>

<script>
    /*eslint-disable*/
    import preview from '../../../utils/multiplication-and-division/preview';

    const { noun } = require('plural-ru');
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [TrainerUtilities, preview],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {
            timeLimit() {
                return (
                    this.parameters.timeLimit +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit)
                );
            },
            answers() {
                if (this.parameters.positiveAnswers && this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersAny');
                }
                if (this.parameters.positiveAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyPositive');
                }
                if (this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyNegative');
                }
            },
        },
    };
</script>
